<!--数据列表 Sag 2020-04-15-->
<template>
  <div class="its-data-list" :class="{'its-subject-list': user&&user.userType=='TEACHER'&&subjects.length>0, 'its-user-student': user&&user.userType=='STUDENT'}">
    <div class="its-nav">
      <div class="its-crumbs">
        <span class="its-nav-item" v-if="navs.length>0" @click="toPre"><i class="el-icon-arrow-left"></i>&nbsp;</span>
        <span class="its-nav-item" @click="toTop">全部文件&nbsp;<template v-if="navs.length>0">></template>&nbsp;</span>
        <span class="its-nav-item" v-for="(nav,i) in navs" :key="i" @click="toLevel(nav)">{{nav.fileName}}&nbsp;<template v-if="i < navs.length-1">>&nbsp;</template></span>
      </div>
      <!-- <el-select v-if="user&&user.userType=='TEACHER'&&subjects.length>0" class="its-select fr" size="mini" v-model="subject.id" @change="changeSubject">
        <el-option v-for="(d, i) in subjects" :key="i" :label="d.name" :value="d.id"></el-option>
      </el-select> -->
    </div>
    <ts-div-guide-page v-if="guide" class="its-data-list" :item=guide></ts-div-guide-page>
    <template v-else>
      <data-table ref="dataTable" v-if="sortedBy==='table'" :user="user" :page="page" :default-sort="defaultSort" :tableData="tableData" @selectedItems="getSelectedItems" :checkedItems="selectedItems" :father-action="dataTableAction" @show-preview="showPreview"></data-table>
      <data-grid ref="dataGrid" v-else :tableData="tableData" @selectedItems="getSelectedItems" :checkedItems="selectedItems" :father-action="dataTableAction" @show-preview="showPreview"></data-grid>
    </template>
  </div>
</template>
<script>
import DataTable from './DataTable'
import DataGrid from './DataGrid'
import { classSpaceApi } from '../../../../utils/api'
import Vue from 'vue'
export default {
  name: 'DataList',
  components: {
    DataTable,
    DataGrid
  },
  props: {
    searchParams: {
      type: Object,
      default: function () {
        return {// 搜索条件
          fileId: "0",
          keyword: "",
          filePath: "0",
        }
      }
    },
    sortedBy: {
      type: String,
      default: 'table'
    }
  },
  data() {
    return {
      selectedItems: [],//已选的项目
      tableData: [],
      navs: [],
      subject: {}, // 当前所选任教科目
      popoverData: {
        type: 'data-list',
        title: '无',
        items: []
      },
      popoverShow: false,
      subjects: [], // 所有任教科目
      shareClassList: [],//可见班级列表
      defaultSort: {
        prop: 'gmtModified',
        order: 'descending'
      },
      page: {
        total: 0,
        current: 1,
        size: 20,
      },
      orderType: 'UPDATE_TIME_DESC',
      guide: null
    }
  },
  computed: {
    user: function () {
      return this.$store.state.user
    }
  },
  watch: {
    user: {
      handler: function () {
        console.log('----user---', this.user)
        if (this.user) {
          if (this.user.userType === 'TEACHER') {
            // this.getSubjects()
          } else {
            this.subject.id = '-1'
            this.getDataList()
          }
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    // this.getDataList()
  },
  methods: {
    showPreview: function (show) {
      this.$emit('show-preview', show)
    },
    changeSubject: function (subject) {
      let data = JSON.parse(JSON.stringify(subject))
      this.subject = data.subject
      this.subjects = data.subjects
      this.getShareClassList()
      this.getDataList()
    },
    getShareClassList: function () {
      //获取任教科目下的可见班级列表
      classSpaceApi.getShareClass(this.subject.id).then(res => {
        if (res.success) {
          this.shareClassList = res.body
          this.popoverData.title = this.subject.name
          this.popoverData.items = this.subjects
          console.log('subjects', this.subjects)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    getDataList: function () {
      if (!this.orderType) {
        this.orderType = 'UPDATE_TIME_DESC'
      }
      //获取数据列表
      let params = {
        fileId: this.searchParams.fileId,
        keyword: this.searchParams.keyword,
        orderbyType: this.orderType,
        filePath: this.searchParams.filePath,
        currentPage: this.page.current,
        pageSize: this.page.size,
        role: this.user.userType,
        subjectId: this.subject.id
      }
      classSpaceApi.getFileList(params).then((res) => {
        if (res.success) {
          let result = res.body
          this.navs = result.filePathInfoList ? result.filePathInfoList : []
          let tableData = result.classSpaceFileList ? result.classSpaceFileList : []
          if (this.user.userType === 'STUDENT') {
            tableData = result.items
          } else {
            // 如果非学生下一条数据也没，那么展示引导页
            if (parseInt(params.fileId) === 0 && tableData.length === 0) {
              this.setGuide()
              return
            }
          }
          tableData.forEach((item) => {
            item.fileSuffix = this.$options.filters['fileIcon'](item.fileSuffix)
          })
          this.tableData = tableData
          this.guide = null
          this.$nextTick(() => {
            //数据更新，清空之前的选择
            if (this.sortedBy === 'table') {
              //表格
              if (this.$refs.dataTable) {
                this.$refs.dataTable.clearSelections()
              }
            } else {
              //缩略图
              if (this.$refs.dataGrid) {
                this.$refs.dataGrid.clearSelections()
              }
            }
          })
        } else {
          this.$message.error(res.message)
        }
      })
    },
    toPre: function () {
      //返回上一级
      if (this.navs.length > 1) {
        let nav = this.navs[this.navs.length - 2]
        this.searchParams.fileId = nav.id
        this.searchParams.filePath = nav.filePath + '/' + nav.id
        if (this.user.userType != 'TEACHER') {
          // 学生
          this.subject.id = '-1'
        }
      } else {
        this.searchParams.fileId = '0'
        this.searchParams.filePath = '0'
        if (this.user.userType != 'TEACHER') {
          // 学生
          this.subject.id = '-1'
        }
      }
      let dataTable = this.$refs.dataTable
      if (dataTable) {
        dataTable.setDefaultSort()
      }
      this.getDataList()
    },
    toTop: function () {
      if (this.user.userType != 'TEACHER') {
        // 学生
        this.subject.id = '-1'
      }
      //全部文件
      this.searchParams.fileId = '0'
      this.searchParams.filePath = '0'
      let dataTable = this.$refs.dataTable
      if (dataTable) {
        dataTable.setDefaultSort()
      }
      this.getDataList()
    },
    toLevel: function (nav) {
      //跳转到指定层
      console.log(nav)
      this.searchParams.fileId = nav.id
      this.searchParams.filePath = nav.filePath + '/' + nav.id
      this.getDataList()
    },
    dataTableAction: function (data) {
      console.log(data)
      //列表操作
      if (data.type === 'name-click') {
        //点击文件名 文件夹
        let item = data.item
        if (item.folder) {
          if (this.user.userType === 'STUDENT' && item.defaultFolder) {
            this.subject.id = item.id
            this.searchParams.filePath = '0'
          } else {
            this.searchParams.filePath = item.filePath + '/' + item.id
            this.searchParams.fileId = item.id
          }
          // 列表布局时，会设置排序
          let dataTable = this.$refs.dataTable
          if (dataTable) {
            dataTable.setDefaultSort()
          }
          this.getDataList()
        } else {
          //文件
        }
      } else if (data.type === 'sort') {
        //文件排序
        let sort = data.item
        let sortStr = 'UPDATE_TIME'
        if (sort.prop === 'gmtModified') {
          sortStr = 'UPDATE_TIME'
        } else if (sort.prop === 'fileSize') {
          sortStr = 'FILE_SIZE'
        }
        if (sort.order === 'descending') {
          sortStr += '_DESC'
          this.$refs.dataTable.setDefaultSort(sort)
        } else if (sort.order === 'ascending') {
          sortStr += '_ASC'
          this.$refs.dataTable.setDefaultSort(sort)
        } else {
          //默认时间降序排列
          sortStr = 'UPDATE_TIME_DESC'
          this.$refs.dataTable.setDefaultSort()
        }
        this.orderType = sortStr
        this.getDataList()
      } else if (data.type === 'page') {
        this.page.current = data.data || 1
        this.getDataList()
      }
    },
    getSelectedItems: function (data) {
      if (data.length > 0) {
        this.selectedItems = JSON.parse(JSON.stringify(data))
      } else {
        this.selectedItems = []
      }
      this.$emit('showMoreOption', this.selectedItems.length)
    },
    setGuide: function () {
      this.guide = {
        empty: '',
        guides: {
          part1: [
            '<p style="text-align: center;">您还没上传过班级资料，快去<span id="upload"></span>吧~</p>'
          ],
          part2: [
            '<p style="color: #333333;font-size: 20px;font-weight:bold">上传学生学习资料并分享给学生，再也不用担心学生遗失复习资料啦~</p>'
          ]
        },
        file: {
          type: 'video',
          urls: ['https://e.xkw.com/ibook/other/ektcxb/%E7%8F%AD%E7%BA%A7%E8%B5%84%E6%96%99%E5%BC%95%E5%AF%BC%E8%A7%86%E9%A2%91.mp4'] // 绝对地址
        }
      }
      const TemComponent = Vue.extend({
        template: '<a @click="upload()" style="color: #0076f1;cursor: pointer;">上传</a>',
        methods: {
          upload() {
            this.$parent.fileAction({ type: 'upload' })
          }
        }
      })
      this.$nextTick(() => {
        new TemComponent({ parent: this.$parent.$parent }).$mount(document.getElementById('upload'))
      })
    }
  }
}
</script>
<style>
.data-list {
  top: 198px !important;
}
</style>
<style scoped>
.its-data-list {
  background-color: white;
  margin-top: 10px;
  min-height: calc(100vh - 226px);
}

.its-data-list >>> .el-dropdown-link {
  float: right;
  font-size: 14px;
  color: black;
  opacity: 0.9;
}
.its-nav {
  padding: 20px;
  position: relative;
}
.its-nav span {
  cursor: pointer;
  word-break: break-all;
  display: inline-block;
  vertical-align: middle;
}
.its-nav span:hover {
  opacity: 0.8;
  color: #5591fe;
}
.its-crumbs {
  display: inline-block;
  width: 1000px;
}

.its-crumbs .its-nav-item:last-child {
  color: #5591fe;
}
.its-subjects-select {
  width: 120px;
  position: absolute;
  right: 20px;
  top: 13px;
}
.its-subject {
  float: right;
  width: 120px;
}
.its-subject span {
  font-size: 14px;
  color: black;
  opacity: 0.9;
}
.its-select {
  width: 100px;
}
.its-select >>> .el-input__inner {
  border: none;
}

.its-user-student {
  min-height: calc(100vh - 166px);
}

.el-icon-arrow-left {
  font-weight: bolder;
  font-size: 18px;
  float: left;
  margin-top: 1px;
}
</style>
